import { computed } from 'vue'

export function useTypesenseSearchQueryUrl(payload: any) {
  const {
    searchParameters,
    currentFacets,
    updateCurrentFacets
  } = payload

  function searchQueryBuildFromUrl(payload: any = {}) {
    if (payload.query) {
      searchParameters.query = decodeURIComponent(payload.query)
      delete payload.query
    }
    if (payload.exactMatch) {
      searchParameters.exactMatch = decodeURIComponent(payload.exactMatch) === 'true'
      delete payload.exactMatch
    }

    // `active` is set to `true` by default. Current logic will remove facet if the value it receives is already exists
    // This handles most loading conditions
    if (payload?.active === 'true') {
      currentFacets.value.active = new Set(['true'])
      delete payload.active
    }

    const keys = Object.keys(payload)

    keys.forEach((i: string) => {
      // if isArray
      if (Array.isArray(payload[i])) {
        payload[i].forEach((value: any) => {
          updateCurrentFacets({ key: i, value: decodeURIComponent(value), skipGetResults: true })
        })
      }
      // if string
      else {
        updateCurrentFacets({ key: i, value: decodeURIComponent(payload[i]), skipGetResults: true })
      }
    })
  }

  const searchQueryUrl = computed(() => {
    const queries = []
    if (searchParameters.query)
      queries.push(`query=${encodeURIComponent(searchParameters.query)}`)
    if (searchParameters.exactMatch)
      queries.push('exactMatch=true')

    const keys = Object.keys(currentFacets.value)
    keys.forEach((key: string) => {
      currentFacets.value[key].forEach((value: any) => {
        queries.push(`${key}=${encodeURIComponent(value)}`)
      })
    })
    return queries.length ? queries.join('&') : ''
  })

  return {
    searchQueryUrl,
    searchQueryBuildFromUrl
  }
}
